"use strict";
document.addEventListener("DOMContentLoaded", function() {
    var changeSlide = function changeSlide(n) {
        showSlide(slideIndex += n);
    };
    var showSlide = function showSlide(n) {
        if (!sliderImages.length) return;
        if (n > sliderImages.length) slideIndex = 1;
        if (n < 1) slideIndex = sliderImages.length;
        Array.from(sliderImages).forEach(function(img) {
            img.style.display = "none";
        });
        sliderImages[slideIndex - 1].style.display = "block";
    };
    var startAutoPlay = function startAutoPlay() {
        stopAutoPlay();
        intervalId = setInterval(function() {
            return changeSlide(1);
        }, 5000);
    };
    var stopAutoPlay = function stopAutoPlay() {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
    };
    var slideIndex = 1;
    var intervalId;
    var sliderImages = document.getElementsByClassName("slider__img");
    var prevButton = document.querySelector(".slider__button--prev");
    var nextButton = document.querySelector(".slider__button--next");
    var links = document.querySelectorAll(".autofocus-link");
    var contactForm = document.getElementById("contact-form");
    var firstInput = contactForm === null || contactForm === void 0 ? void 0 : contactForm.querySelector("input:first-of-type");
    if (prevButton && nextButton) {
        prevButton.addEventListener("click", function() {
            stopAutoPlay();
            changeSlide(-1);
        });
        nextButton.addEventListener("click", function() {
            stopAutoPlay();
            changeSlide(1);
        });
    }
    if (links.length && contactForm && firstInput) links.forEach(function(link) {
        link.addEventListener("click", function(event) {
            event.preventDefault();
            window.location.hash = "contact-form";
            firstInput.focus();
            contactForm.scrollIntoView({
                block: "start",
                behavior: "smooth"
            });
        });
    });
    showSlide(slideIndex);
    startAutoPlay();
});

//# sourceMappingURL=index.61679413.js.map
